module.exports = {
    controller: customsRulingsSearchPageController,
    templateUrl: 'cross/components/customs-rulings-search-page.html'
};

customsRulingsSearchPageController.$inject = [
    '$analytics', 
    '$location', 
    '$route', 
    'crossDataService', 
    'searchService',
];

function customsRulingsSearchPageController(
    $analytics, 
    $location, 
    $route, 
    crossDataService, 
    searchService
) {
    var vm = {
        $onInit: attached,
        showSearchSubNav: $route.current.$$route.showSearchSubNav,
        service: crossDataService,
        isLoading: false,
        loadNew: loadNew
    };

    return vm;

    function attached() {
        $analytics.pageTrack('/customs-rulings-search');
        crossDataService.resetFilter();
        var q = searchService.parseLocationSearchObject($location.search());
        crossDataService.filter.goodsCode = q.commodityCode;
        crossDataService.filter.subjectQuery = q.query;
        loadNew();
    }

    function loadNew() {
        vm.isLoading = true;
        crossDataService.loadNewRulings()
            .then(function () {
                vm.isLoading = false;
            });
    }
}